const initialState = {
	curated_autoplay_speed: 200,
	collapsible_speed: 150,
	site_title: 'Studio TM',
	site_description: '',
	site_contact: '',
	nav_title: 'Works',
};

const configReducer = (state=initialState, action) => {
	switch (action.type) {
		case 'FETCH_CONFIG_SUCCESS':
			return { ...state, 
				site_description: action.payload.data.aboutIntro,
				site_contact: action.payload.data.contactInformation 
			};

		default:
			return state;
	}
}

export default configReducer;


// WEBPACK FOOTER //
// ./src/reducers/config.jsx